module.exports = __webpack_public_path__ + "img/gender.8e2fd6ea.svg";